<h1>Operator Notifications</h1>

<div class="messageLog">
	@for ( msg of messageLog; track msg ) {
	<div>
		@for ( item of msg.error; track item ) {
		<li>
  			<span class={{item.html}}>{{item.message}}</span>
  		</li>
		}
  	</div>
	}
</div>